import _ from "lodash";
import SendOTPTemplate from "./template";

const RegisterAccountSendOTP = ({ loading, userInfo = {}, onSendOTP }) => {
	const onFinish = async (type) => {
		onSendOTP?.(type);
	};

	const initProps = {
		loading,
		email: userInfo?.email,
		phone: userInfo?.phone,
		onFinish: onFinish,
	};
	return <SendOTPTemplate {...initProps} />;
};

export default RegisterAccountSendOTP;
